export const LIVE_PREVIEW_MOBILE_INDEX = 1;
